module.exports = __webpack_public_path__ + "static/img/custom_design.6972db6d.png";